import Swiper, { Navigation, Pagination } from "swiper";
import "swiper/swiper-bundle.css";

// configure Swiper to use modules
// core version + navigation, pagination modules:
Swiper.use([Navigation, Pagination]);

$(document).ready(() => {
  // =====================================================
  //      Detail slider
  // =====================================================

  var detailSlider = new Swiper(".detail-slider", {
    slidesPerView: 1.6, // slides per view on smallest viewport
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    breakpoints: {
      // override slidesPerView for larger viewports below
      991: {
        slidesPerView: 3.6,
      },
      565: {
        slidesPerView: 1.6,
      },
    },

    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // =====================================================
  //      Init swipers automatically
  // =====================================================

  $(".swiper-init").each(function () {
    var slider = $(this),
      configuration = JSON.parse($(this).attr("data-swiper"));

    new Swiper(slider, configuration);
  });

  // =====================================================
  //      Items slider
  // =====================================================

  var itemsSlider = new Swiper(".items-slider", {
    cssMode: true, // use CSS Scroll Snap API => improved performance
    slidesPerView: 1, // slides per view on smallest viewport
    spaceBetween: 20,
    loop: false,
    roundLengths: true,
    breakpoints: {
      // override slidesPerView for larger viewports below
      1200: {
        slidesPerView: 4,
      },
      991: {
        slidesPerView: 3,
      },
      565: {
        slidesPerView: 2,
      },
    },

    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
  });
});
